import React, { useCallback, useEffect, useState } from 'react'
import styled, { css } from 'styled-components'
import useEmblaCarousel from 'embla-carousel-react'

import { Button } from '../../styles/Buttons'
import { Heading2, Paragraph } from '../../styles/Text'

const Heading = styled(Heading2)`
  margin-bottom: 32px;
`

const Wrapper = styled.div`
  width: 100%;
  padding: 16px;
  background-color: #c7b9ff;
`

const TextSection = styled.div`
  width: 50%;
`

const ImageSection = styled.div`
  width: 50%;
  img {
    width: 100%;
  }
`

const ItemHeading = styled(Heading2)``

const ItemText = styled.div`
  margin-top: 8px;
`

const ItemButtonWrapper = styled.div`
  padding-top: 32px;
  margin-top: auto;
`

const EmblaCarousel = styled.div`
  overflow: hidden;
`

const EmblaCarouselInner = styled.div`
  display: flex;
`

const SlideWrapper = styled.div`
  flex: 0 0 100%;
  display: flex;
  align-items: center;
  column-gap: 32px;
  padding-left: 16px;
  padding-right: 16px;
`

const DotButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 56px;
  margin-left: auto;
  margin-right: auto;
`

const DotButton = styled.button`
  width: 12px;
  height: 12px;
  transition: all 0.1s ease;
  background-color: ${(p) => p.theme.textColor};
  border-radius: 50%;
  :not(:last-child) {
    margin-right: 12px;
  }
  ${(p) =>
    p.selected &&
    css`
      background-color: white;
    `}
`

const Carousel = () => {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: false })

  const [selectedIndex, setSelectedIndex] = useState(0)
  const [scrollSnaps, setScrollSnaps] = useState([])

  const scrollTo = useCallback((index) => emblaApi.scrollTo(index), [emblaApi])

  useEffect(() => {
    const onSelect = () => {
      setSelectedIndex(emblaApi.selectedScrollSnap())
    }
    if (emblaApi) {
      setScrollSnaps(emblaApi.scrollSnapList())
      emblaApi.on('select', onSelect)
      onSelect()
    }
    return () => emblaApi && emblaApi.destroy()
  }, [emblaApi])

  return (
    <>
      <Heading>Carousel</Heading>
      <Wrapper>
        <EmblaCarousel ref={emblaRef}>
          <EmblaCarouselInner>
            <Slide />
            <Slide />
            <Slide />
          </EmblaCarouselInner>
        </EmblaCarousel>
        <DotButtonContainer>
          {scrollSnaps.map((snap, index) => {
            return (
              <DotButton
                key={index}
                selected={index === selectedIndex}
                onClick={() => {
                  scrollTo(index)
                }}
                aria-label="Change slide"
              ></DotButton>
            )
          })}
        </DotButtonContainer>
      </Wrapper>
    </>
  )
}

export default Carousel

const Slide = () => {
  return (
    <SlideWrapper>
      <TextSection>
        <ItemHeading>Heading</ItemHeading>
        <ItemText>
          <Paragraph>
            Lorem ipsum dolor sit amet, consectetur adipisg elit, sed do eiusmod tempor incididunt ut labore et dolore
            magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco nisi ut aliquip ex ea commodo
            consequat.
          </Paragraph>
        </ItemText>
        <ItemButtonWrapper>
          <Button dark>Find out more</Button>
        </ItemButtonWrapper>
      </TextSection>
      <ImageSection>
        <img src="/images/chameleon/fixed-aspect-ratio-spacer.png" alt="" />
      </ImageSection>
    </SlideWrapper>
  )
}
